const CompanyBranding = () => {
	return (
		<div className="flex items-center flex-shrink-0 px-4 gap-3 border-b border-gray-200 pb-3">
			<img src={'/logo_v2.svg'} className="h-7 w-auto" alt="Company Logo" />
			<h5 className="font-light text-lg text-gray-900 line-clamp-1">
				AppMaker
			</h5>
		</div>
	);
};

export default CompanyBranding;
